'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEventAnimationEnd = function getEventAnimationEnd() {
  return window && window.webkitAnimationEnd ? 'webkitAnimationEnd' : 'animationend';
};

exports.getEventAnimationEnd = getEventAnimationEnd;


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-vue/dist/commonjs/lib/animationHelper.js
// module id = 196
// module chunks = 4